<template>
  <div>
    <button class="openButton" @click="$emit('openNotification')">
      <BaseIcon name="notificationAlertIcon" />
    </button>
  </div>
</template>
<script>
export default {};
</script>
<style>
.openButton {
  background: transparent;
  border: transparent;
  margin-right: 0.938rem;
}
</style>
